import { useField } from 'formik'
import { OnChangeValue } from 'react-select'

import { Option } from '@models/option'

import { AdministrativeDivisionInput, AdministrativeDivisionInputProps } from './AdministrativeDivisionInput'
import { useFirstTimeEffect } from '@/hooks'

type Props<IsMulti extends boolean> = Omit<AdministrativeDivisionInputProps<IsMulti>, 'name' | 'onChange'> & {
  name: string
  /**
   * @deprecated use countryId instead
   */
  countryFieldName?: string
  /**
   * @deprecated use parentId instead
   */
  parentFieldName?: string | null
  onChange?: (value: OnChangeValue<Option, IsMulti>) => void
}

const AdministrativeDivisionInputField = <IsMulti extends boolean = false>({
  name,
  countryId,
  parentId,
  onChange,
  ...props
}: Props<IsMulti>) => {
  const [field,, helper] = useField(name)

  const handleChange = (newValue: OnChangeValue<Option, IsMulti>) => {
    helper.setValue(newValue)
  }

  const handleBlur = () => {
    helper.setTouched(true)
  }

  useFirstTimeEffect((isFirstTime) => {
    if (!isFirstTime && onChange) {
      onChange(field.value)
    }
  }, [field.value])

  return (
    <AdministrativeDivisionInput
      {...props}
      {...field}
      countryId={countryId}
      parentId={parentId}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}

export { AdministrativeDivisionInputField }
